
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
@Component({})
export default class DepartmentBudgetSheet extends Vue {
    @Prop({ default: () => [] })
    rows!: Array<any>;
    @Prop({ default: () => [] })
    activeProjectConversionFactor!: number;
    @Prop({ default: () => [] })
    lineSplit!: number;
    @Prop({ default: () => [] })
    disabled!: boolean;
    @Prop({ default: () => [] })
    projectYear!: number;
    
    forceReload = 0;

    updateLineSum(departmentId: any, proposedBudget: number, approvedBudget: number, realignedBudget: number, actualCost: number) {
      this.$emit('lineValueChanged', {departmentId, proposedBudget, approvedBudget, realignedBudget, actualCost})
    }

    proposedCalculateTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.proposedBudget || 0), 0);
    }
    proposedCalculateTotalK$(rows: any[]) {
      return rows.reduce((acc, row) => acc + ((row.proposedBudget * this.lineSplit) || 0), 0);
    }
    proposedCalculateTotalKNGN(rows: any[]) {
      return rows.reduce((acc, row) => acc + ((row.proposedBudget * (1 - this.lineSplit) * this.activeProjectConversionFactor) || 0), 0);
    }

    approvedCalculateTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.approvedBudget || 0), 0);
    }
    approvedCalculateTotalK$(rows: any[]) {
      return rows.reduce((acc, row) => acc + ((row.approvedBudget * this.lineSplit) || 0), 0);
    }
    approvedCalculateTotalKNGN(rows: any[]) {
      return rows.reduce((acc, row) => acc + ((row.approvedBudget * (1 - this.lineSplit) * this.activeProjectConversionFactor) || 0), 0);
    }

    reAllignedCalculateTotal(rows: any[]) {
      return rows.reduce((acc, row) => acc + (row.realignedBudget || 0), 0);
    }
    reAllignedCalculateTotalK$(rows: any[]) {
      return rows.reduce((acc, row) => acc + ((row.realignedBudget * this.lineSplit) || 0), 0);
    }
    reAllignedCalculateTotalKNGN(rows: any[]) {
      return rows.reduce((acc, row) => acc + ((row.realignedBudget * (1 - this.lineSplit) * this.activeProjectConversionFactor) || 0), 0);
    }

    mounted() {
      this.forceReload += 1;
    }
}
